// Calculadora WoW (Care 3 · Care 6 · Flex · Flex Ilimitado) — orçamentos do HUB.
// PREÇO: tabela de preços por escalão da folha «WoW_Calculadora_Comercial» (6/ago/2026), SEM DEGRAUS — entre o início de um
//   escalão e o do seguinte, o preço por colaborador desce em linha reta. Assim uma empresa maior nunca paga menos no total
//   do que uma mais pequena, e não há saltos aos 250, 500, 1000… (decisão da Cátia, 25/10/2026).
//   + add-on por área extra (0,05 €/colab./mês por cada área além da 1.ª) · sem Psicologia paga 55% · mínimo 250 €/mês.
// CUSTO: consultas previstas (colaboradores × adesão × consultas por pessoa) × 22,50 € — serve para a margem; aviso abaixo de 40%.

export const CUSTO_CONSULTA = 22.5;
export const SESSOES = { 'Care 3': 3, 'Care 6': 6, 'Flex': 8, 'Flex Ilimitado': 10 };
export const MINIMO_MENSAL = 250;
export const ADDON_AREA = 0.05;
export const AREAS_PADRAO = 6;
export const FATOR_SEM_PSICOLOGIA = 0.55;
export const MARGEM_MINIMA = 0.40;

// TODOS OS PLANOS (Care 3, Care 6, Flex, Flex Ilimitado — desde 05/11/2026; antes só o Flex): o preço sai das consultas previstas por ano × valor médio da consulta, e o valor
//   depende do VOLUME DE CONSULTAS (decisão da Cátia, 30/10/2026): até 100 consultas/ano 60 €, até 500 55 €, a partir de 501 50 €.
//   Para mais consultas nunca dar um total mais baixo, o total não desce abaixo do máximo do escalão anterior
//   (ex.: 101 consultas × 55 € = 5555 € → fica 6000 €, o mesmo que 100 × 60 €). O comercial pode pôr outro valor.
export const ESCALOES_CONSULTA = [ { ate: 100, valor: 60 }, { ate: 500, valor: 55 }, { ate: Infinity, valor: 50 } ];
export const ehFlex = (plano) => /^Flex/.test(String(plano || ''));
export function valorConsultaBase(consultas) {
  consultas = Number(consultas) || 0;
  return ESCALOES_CONSULTA.find(e => consultas <= e.ate).valor;
}
// total anual mínimo para este nº de consultas: o máximo do escalão anterior
function pisoEscalao(consultas) {
  let piso = 0;
  for (const e of ESCALOES_CONSULTA) { if (consultas > e.ate) piso = e.ate * e.valor; }
  return piso;
}

export const PLANO_POR_CODIGO = { THR11: 'Care 3', THR12: 'Care 6', THR14: 'Flex', THR13: 'Flex Ilimitado' };

// tabela de preços (€/colaborador/mês) no início de cada escalão
const ESCALOES = [1, 50, 100, 250, 501, 1000, 2000, 5000];
export const TABELA = {
  'Care 3': [2.5, 2, 1.5, 1.3, 1, 0.85, 0.6, 0.45],
  'Care 6': [3.5, 3, 2.5, 1.66, 1.3, 1, 0.95, 0.7],
  'Flex':   [4, 3.5, 2.7, 1.8, 1.5, 1.2, 1, 0.85],
};
// Flex Ilimitado não está na folha: Flex × 10/8 (10 consultas por pessoa em vez de 8)
TABELA['Flex Ilimitado'] = TABELA['Flex'].map((v) => Math.round(v * 1.25 * 100) / 100);

export function precoTabela(plano, n) {
  const t = TABELA[plano]; if (!t || !n) return null;
  for (let i = 0; i < ESCALOES.length - 1; i++) {
    if (n < ESCALOES[i + 1]) return t[i] + (t[i + 1] - t[i]) * (n - ESCALOES[i]) / (ESCALOES[i + 1] - ESCALOES[i]);
  }
  return t[t.length - 1];
}

// adesão esperada por dimensão (para as consultas previstas e o custo), SEM DEGRAUS (decisão da Cátia, 30/10/2026):
//   os valores da tabela (12% · 10% aos 250 · 8% aos 501 · 4% aos 1000 · 3,5% aos 2000 · 2,5% aos 5000) servem de pontos
//   de referência (até 249 fica nos 12%) e o nº de UTILIZADORES previstos (colaboradores × adesão) cresce em linha reta entre eles — nunca desce.
//   Assim uma empresa maior nunca tem menos consultas previstas (nem paga menos) do que uma mais pequena.
const PONTOS_ADESAO = [[1, 0.12], [249, 0.12], [250, 0.10], [501, 0.08], [1000, 0.04], [2000, 0.035], [5000, 0.025]];
function utilizadoresPrevistos(n) {
  const pts = PONTOS_ADESAO.map(([x, a]) => [x, x * a]);
  for (let i = 1; i < pts.length; i++) pts[i][1] = Math.max(pts[i][1], pts[i - 1][1]);   // nunca desce
  if (n <= pts[0][0]) return n * PONTOS_ADESAO[0][1];
  for (let i = 0; i < pts.length - 1; i++) {
    const [x0, u0] = pts[i], [x1, u1] = pts[i + 1];
    if (n < x1) return u0 + (u1 - u0) * (n - x0) / (x1 - x0);
  }
  const [xu, uu] = pts[pts.length - 1];
  return uu + (n - xu) * PONTOS_ADESAO[PONTOS_ADESAO.length - 1][1];
}
export function adesaoBase(n) {
  n = Number(n) || 0; if (!n) return 0;
  return Math.round(utilizadoresPrevistos(n) / n * 10000) / 10000;
}

export function calcularWow({ plano, n, adesaoPct = '', areas = AREAS_PADRAO, addon = ADDON_AREA, excluiPsicologia = false, minimo = MINIMO_MENSAL, valorConsulta = '' }) {
  n = Number(n) || 0; areas = Number(areas) || 0; addon = Number(addon) || 0; minimo = Number(minimo) || 0;
  const sessoes = SESSOES[plano] || 0;
  if (!n || !sessoes || !TABELA[plano]) return null;
  const addOns = Math.max(0, areas - 1) * addon;
  const fator = excluiPsicologia ? FATOR_SEM_PSICOLOGIA : 1;
  // custo previsto: a adesão vem da tabela por dimensão, mas o comercial pode pôr outra
  const adesaoTabela = adesaoBase(n);
  const adesao = adesaoPct !== '' && adesaoPct != null && !isNaN(Number(adesaoPct)) ? Number(adesaoPct) / 100 : adesaoTabela;
  // consultas previstas por ano (sem adesão manual, a partir dos utilizadores previstos — sem arredondar a adesão)
  const consumo = adesao === adesaoTabela ? Math.round(utilizadoresPrevistos(n) * sessoes) : Math.round(n * adesao * sessoes);
  // Care 3, Care 6 e Flex: todos pela tabela de valor por consulta (decisão da Cátia, 05/11/2026) — o plano só muda as consultas por pessoa
  const flex = true;
  const valorConsultaTabela = flex ? valorConsultaBase(consumo) : null;
  const vcManual = flex && valorConsulta !== '' && valorConsulta != null && !isNaN(Number(valorConsulta)) && Number(valorConsulta) > 0;
  const vConsulta = flex ? (vcManual ? Number(valorConsulta) : valorConsultaTabela) : null;
  // Flex: € por colaborador/mês = consultas previstas × valor médio (com o piso do escalão) ÷ 12 ÷ colaboradores
  const anualFlex = flex ? (vcManual ? consumo * vConsulta : Math.max(consumo * vConsulta, pisoEscalao(consumo))) : 0;
  const aplicouPisoEscalao = flex && !vcManual && anualFlex > consumo * vConsulta;
  const tabela = flex ? (anualFlex / 12 / n) : precoTabela(plano, n);
  const precoColab = (tabela + addOns) * fator;                       // € por colaborador/mês
  const totalCalculado = n * precoColab;
  const totalMensal = Math.max(minimo, totalCalculado);
  const custoAnual = consumo * CUSTO_CONSULTA * fator;
  const custoMensal = custoAnual / 12;
  const margem = totalMensal > 0 ? 1 - custoMensal / totalMensal : 0;
  return { plano, n, tabela, addOns, precoColab, totalCalculado, totalMensal, totalAnual: totalMensal * 12, valorColabAno: precoColab * 12,
    aplicouMinimo: totalCalculado < minimo, adesao, adesaoTabela, adesaoManual: adesao !== adesaoTabela, sessoes, consumo, custoAnual, custoMensal,
    margem, margemBaixa: margem < MARGEM_MINIMA,
    flex, aplicouPisoEscalao, valorConsulta: vConsulta, valorConsultaTabela, valorConsultaManual: vcManual,
    valorConsultaReal: consumo > 0 ? (totalMensal * 12) / consumo : null };
}
